export default __webpack_public_path__ + "static/media/KOD0017-min.d18133b3.webp";